import React from 'react';

function ChatList({ chats, onChatClick, onApprove, onReject }) {
  if (chats.length === 0) {
    return (
      <div className="chat-list">
        <div className="chat-list-header">
          <h2>채팅 목록</h2>
        </div>
        <div className="empty-state">
          <p>새로운 채팅이 없습니다.</p>
        </div>
      </div>
    );
  }

  const getStatusBadge = (status) => {
    if (status === 'approved') return <span className="status-badge approved">전송됨</span>;
    if (status === 'rejected') return <span className="status-badge rejected">보류됨</span>;
    return <span className="status-badge pending">대기중</span>;
  };

  const getMessageTypeBadge = (type) => {
    if (type === 'quote_request') return <span className="type-badge quote">💰 견적요청</span>;
    if (type === 'general_inquiry') return <span className="type-badge general">💬 일반문의</span>;
    if (type === 'follow_up') return <span className="type-badge follow">📝 후속</span>;
    return null;
  };

  return (
    <div className="chat-list">
      <div className="chat-list-header">
        <h2>채팅 목록</h2>
        <span className="badge">{chats.length}</span>
      </div>
      <div className="chat-items">
        {chats.map((chat) => (
          <div
            key={chat.id}
            className={`chat-item ${chat.isRead ? '' : 'unread'} ${chat.approvalStatus}`}
          >
            <div className="chat-item-header">
              <div className="chat-header-left">
                <span className="chat-sender">{chat.senderName}</span>
                {chat.messageType && getMessageTypeBadge(chat.messageType)}
              </div>
              <span className="chat-time">{formatTime(chat.timestamp)}</span>
            </div>
            <div className="chat-item-body" onClick={() => onChatClick(chat)}>
              <p className="chat-message">{chat.message}</p>
              {!chat.isRead && <span className="unread-badge">NEW</span>}
            </div>

            {/* AI 답변 표시 */}
            {chat.aiResponse && (
              <div className="ai-response-box">
                <div className="ai-response-header">
                  <span className="ai-label">🤖 AI 생성 답변</span>
                  {getStatusBadge(chat.approvalStatus)}
                </div>
                <div className="ai-response-content">
                  {chat.aiResponse.substring(0, 150)}
                  {chat.aiResponse.length > 150 && '...'}
                </div>
                {chat.classificationReason && (
                  <div className="classification-reason">
                    <small>분류 이유: {chat.classificationReason}</small>
                  </div>
                )}

                {/* 승인/보류 버튼 */}
                {chat.approvalStatus === 'pending' && (
                  <div className="approval-buttons">
                    <button
                      className="btn btn-approve"
                      onClick={(e) => {
                        e.stopPropagation();
                        onApprove(chat.id);
                      }}
                    >
                      ✅ 전송
                    </button>
                    <button
                      className="btn btn-reject"
                      onClick={(e) => {
                        e.stopPropagation();
                        onReject(chat.id);
                      }}
                    >
                      ⏸️ 보류
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function formatTime(timestamp) {
  const date = new Date(timestamp);
  const now = new Date();
  const diff = now - date;

  // 1분 미만
  if (diff < 60000) {
    return '방금 전';
  }

  // 1시간 미만
  if (diff < 3600000) {
    return `${Math.floor(diff / 60000)}분 전`;
  }

  // 24시간 미만
  if (diff < 86400000) {
    return `${Math.floor(diff / 3600000)}시간 전`;
  }

  // 그 외
  return date.toLocaleDateString('ko-KR');
}

export default ChatList;
